'use strict';

intellidealerAppCoreModule.factory('loginResource', function ($resource, appConfigurationService) {
  return $resource(appConfigurationService.basePath + '/login', {}, {post: {method: 'POST'}});
});
